import { useAuth } from "@/context/AuthContext";
import { useNavigate, useLocation } from "react-router-dom";
import { LogOut, ShieldCheck, User } from "lucide-react";

export function Nav() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  const isCustomer = user?.role === "customer";

  return (
    <header className="sticky top-0 z-50 bg-white/80 backdrop-blur-xl border-b border-zinc-200/70">
      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
        <div className="flex items-center gap-8">
          <div
            className="flex items-center gap-2 cursor-pointer select-none"
            onClick={() => navigate(user?.role === "admin" ? "/admin" : "/welcome")}
            data-testid="nav-logo"
          >
            <img src="/paslogo.png" alt="Peregrine Companies" className="h-9 w-auto" />
            <div className="leading-tight border-l border-zinc-200 pl-3 hidden sm:block">
              <div className="font-display font-extrabold text-sm tracking-tight text-[#0F172A]">
                PEREGRINE COMPANIES
              </div>
              <div className="text-[10px] uppercase tracking-[0.2em] text-zinc-500">Credit Reference Portal</div>
            </div>
          </div>
          {isCustomer && (
            <nav className="hidden md:flex items-center gap-1">
              <button
                onClick={() => navigate("/welcome")}
                data-testid="nav-welcome"
                className={`px-3 py-2 text-sm transition-colors ${
                  location.pathname === "/welcome" ? "text-[#0F172A] font-medium" : "text-zinc-500 hover:text-[#0F172A]"
                }`}
              >
                Welcome
              </button>
              <button
                onClick={() => navigate("/reference-form")}
                data-testid="nav-form"
                className={`px-3 py-2 text-sm transition-colors ${
                  location.pathname === "/reference-form" ? "text-[#0F172A] font-medium" : "text-zinc-500 hover:text-[#0F172A]"
                }`}
              >
                Credit Reference Form
              </button>
            </nav>
          )}
          {(user?.role === "admin" || user?.role === "sales") && (
            <nav className="hidden md:flex items-center gap-1">
              <button
                onClick={() => navigate("/admin")}
                data-testid="nav-credit-portal"
                className={`px-3 py-2 text-sm transition-colors ${
                  location.pathname === "/admin" ? "text-[#0F172A] font-medium" : "text-zinc-500 hover:text-[#0F172A]"
                }`}
              >
                Credit Portal
              </button>
              <button
                onClick={() => navigate("/crm")}
                data-testid="nav-crm-portal"
                className="px-3 py-2 text-sm text-zinc-500 hover:text-[#0F172A] transition-colors"
              >
                CRM Portal
              </button>
            </nav>
          )}
        </div>
        <div className="flex items-center gap-4">
          <div className="hidden sm:flex items-center gap-2 text-sm text-zinc-600">
            {user?.role === "admin" ? (
              <ShieldCheck className="h-4 w-4 text-[#D4AF37]" />
            ) : (
              <User className="h-4 w-4 text-zinc-400" />
            )}
            <span className="font-medium text-[#0F172A]" data-testid="nav-username">{user?.name}</span>
          </div>
          <button
            onClick={handleLogout}
            data-testid="logout-btn"
            className="flex items-center gap-2 px-3 py-2 text-sm text-zinc-600 hover:text-[#EF4444] transition-colors"
          >
            <LogOut className="h-4 w-4" />
            <span className="hidden sm:inline">Sign out</span>
          </button>
        </div>
      </div>
    </header>
  );
}
